if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.container = this.closest('.m-sticky-addtocart');
      this.main = this.closest('product-info') || document.querySelector('product-info[id^="MainProduct"]');
      if (!this.main) return;
      this.action = this.querySelector('[data-sticky-action]');
      this.selection = this.querySelector('[data-sticky-selection]');
      this.price = this.querySelector('[data-sticky-price]');
      this.msi = this.querySelector('[data-sticky-msi]');
      this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
      this.money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.action.addEventListener('click', () => {
        this.update();
        if (!this.variant) return this.choose();
        const mainButton = this.mainButton;
        if (!mainButton || mainButton.disabled) return;
        const form = mainButton.closest('form');
        if (form && !form.reportValidity()) return this.choose();
        // Submit through the original product form: preserves quantity, properties and cart behavior.
        mainButton.click();
        this.schedule();
      }, { signal });
      this.selection.addEventListener('click', () => this.choose(), { signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      this.main.addEventListener('change', this.schedule, { signal });
      this.observer = new MutationObserver(records => {
        if (records.some(r => !this.container.contains(r.target))) this.schedule();
      });
      this.observer.observe(this.main, { subtree: true, childList: true, attributes: true, characterData: true });
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
      this.update();
    }
    get mainButton() {
      return this.main.querySelector('.m-product-form--main .m-add-to-cart');
    }
    setUnavailable() { this.schedule?.(); }
    update() {
      const button = this.mainButton;
      if (!button) return;
      const picker = this.main.querySelector('variant-picker');
      const variantInput = button.closest('form')?.querySelector('[name="id"]');
      const id = variantInput?.value;
      const fields = Array.from(picker?.querySelectorAll('[data-picker-field]') || []);
      const incomplete = fields.some(field => {
        const select = field.querySelector('select');
        return select ? !select.value || select.selectedOptions[0]?.disabled : !field.querySelector('input:checked');
      });
      const variant = !incomplete && !variantInput?.disabled ? this.variants.find(v => String(v.id) === id) : null;
      this.variant = variant;
      const available = variant && variant.available && !button.disabled;
      const busy = button.classList.contains('m-spinner-loading') || button.getAttribute('aria-busy') === 'true';
      this.action.disabled = !!variant && (!available || busy);
      this.action.textContent = !variant ? this.dataset.chooseLabel : busy ? 'Añadiendo…' : available ? 'Añadir al carrito' : variant.available ? 'Espera un momento…' : 'Agotado';
      this.action.setAttribute('aria-busy', String(busy));
      this.selection.hidden = this.dataset.singleVariant === 'true';
      const mobile = window.matchMedia('(max-width:767px)').matches;
      const sizeIndex = Number(this.dataset.sizeIndex);
      const selectionText = variant ? (mobile && sizeIndex >= 0 ? 'Talla ' + variant.options[sizeIndex] : variant.title) + ' · Cambiar' : this.dataset.chooseLabel;
      if (this.selection.textContent !== selectionText) this.selection.textContent = selectionText;
      this.selection.title = selectionText;
      const displayVariant = variant || this.variants.find(v => v.available) || this.variants[0];
      if (displayVariant) {
        this.price.textContent = this.money.format(displayVariant.price / 100);
        this.msi.textContent = displayVariant.price >= 400000 ? '3 o 6 MSI' : displayVariant.price >= 250000 ? '3 MSI' : '';
        const image = this.querySelector('.mz-sticky-purchase__image');
        const src = displayVariant.featured_image?.src;
        if (image && src && image.dataset.variantSrc !== src) {
          image.src = src + (src.includes('?') ? '&' : '?') + 'width=120';
          image.dataset.variantSrc = src;
        }
      }
      const enabled = this.container.dataset[mobile ? 'showOnMobile' : 'showOnDesktop'] === 'true';
      const headerHeight = window.MinimogSettings?.headerHeight || 66;
      const visible = enabled && button.getBoundingClientRect().bottom <= headerHeight;
      this.container.classList.toggle('is-visible', visible);
      this.container.inert = !visible;
      this.container.setAttribute('aria-hidden', String(!visible));
      document.documentElement.classList.toggle('stick-atc-show', visible);
      const height = this.container.offsetHeight;
      document.documentElement.style.setProperty('--f-sticky-atc-bar-height', height + 'px');
      if (window.MinimogSettings) window.MinimogSettings.stickyAddToCartHeight = height;
    }
    choose() {
      const target = this.main.querySelector('variant-picker') || this.mainButton;
      if (!target) return;
      const headerHeight = window.MinimogSettings?.headerHeight || 66;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
      const reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      window.scrollTo({ top, behavior: reduce ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      document.documentElement.classList.remove('stick-atc-show');
    }
  });
}
